import Team from '../components/team.svelte'
// import lozad from 'lozad'

const { $ } = window

export default {
	init() {
		let $teamWrap = $('#team_wrap')

		if ($teamWrap.length) {
			new Team({
				target: $teamWrap[0],
				props: $teamWrap.data(),
			})
		}
	},
	// finalize() {
	// 	let observer = lozad()
	// 	observer.observe()
	// },
}
